var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 244 244",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Branding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Monogram-Blue-Background",
    transform: "translate(-567.000000, -357.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(564.000000, 357.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Monogram",
    transform: "translate(0.000000, 0.760305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.892662,165.07248 L164.892662,86.343565 C164.892662,83.5395527 162.619561,81.2664516 159.815549,81.2664516 L81.177926,81.2664516 L81.177926,0 L240.993475,0 C243.797487,-1.5457868e-14 246.070588,2.2731011 246.070588,5.0771134 L246.070588,165.07248 L164.892662,165.07248 Z",
    id: "Combined-Shape-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.177926,0 L81.177926,81.2664516 L6.12389787,81.2664516 C4.72189171,81.2664516 3.58534116,80.129901 3.58534116,78.7278949 C3.58534116,78.0551071 3.85241582,77.4098346 4.32788926,76.9338427 L81.177926,0 Z",
    id: "Rectangle-Copy-6",
    opacity: 0.404989
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.070588,171.205824 L246.070588,246.338931 L164.892662,246.338931 L241.736023,169.411772 C242.726851,168.419864 244.334176,168.418988 245.326084,169.409816 C245.802754,169.885967 246.070588,170.532078 246.070588,171.205824 Z",
    id: "Rectangle-Copy-7",
    opacity: 0.404989,
    transform: "translate(205.481625, 205.705706) scale(-1, -1) translate(-205.481625, -205.705706) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.177926,81.2664516 L162.354106,81.2664516 C163.756112,81.2664516 164.892662,82.4030021 164.892662,83.8050083 L164.892662,165.07248 L86.2550394,165.07248 C83.4510271,165.07248 81.177926,162.799379 81.177926,159.995366 L81.177926,81.2664516 Z",
    id: "Rectangle-Copy-8",
    opacity: 0.404989
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSIcon);
export default __webpack_public_path__ + "static/media/sIcon.9de6137f710fe883613f2ffc933e04d3.svg";
export { ForwardRef as ReactComponent };